<template>
    <div class="modal-card view-contact-modal-card projects-modal">
        <header class="modal-card-head">
            <p class="modal-card-title">Company Projects</p>
        </header>
        <section class="modal-card-body">
            <o-table class="fullwidth-table  projects-table is-responsive is-responsive-desktop"
                :data="projectsByCompanyId(companyId)" :bordered="table.bordered" :striped="table.striped"
                :narrowed="table.narrowed" :checkable="table.checkable" :loading="table.loading"
                :mobile-cards="table.mobileCards" :paginated="table.paginated" :per-page="table.perPage"
                :pagination-simple="table.paginationSimple" v-model:selected="selected" :checked-rows="checkedRows"
                @update:checkedRows="$event => checkedRows = $event">

                <template>
                    <o-table-column #default="{ row }" field="name" label="Name" sortable>
                        {{ row.name }}
                    </o-table-column>

                    <o-table-column #default="{ row }" field="completion_date" label="Est. Completion Date" sortable>
                        {{ row.completion_date }}
                    </o-table-column>

                    <o-table-column #default="{ row }" field="borough" label="Borough" sortable>
                        {{ row.borough }}
                    </o-table-column>

                    <o-table-column #default="{ row }" field="status" label="Status" sortable>
                        {{ row.status }}
                    </o-table-column>

                    <o-table-column #default="{ row }" field="assigned_to" label="Assigned" sortable>
                        {{ userNameById(row.assigned_to) }}
                    </o-table-column>

                    <o-table-column #default="{ row }" label="">
                        <router-link :to="{ name: 'projects.show', params: { slug: row.id } }"
                            class="button is-default is-small">View</router-link>
                    </o-table-column>

                </template>

                <template v-slot:empty>
                    <div class="has-text-centered">
                        This table is empty!
                    </div>
                </template>
            </o-table>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Table from './../../mixins/Table';

export default {
    mixins: [Table],

    props: ['companyId'],

    computed: {
        ...mapGetters({
            projectsByCompanyId: 'projectsByCompanyId',
            userNameById: 'userNameById'
        })
    }
}
</script>